/**
 * Historia 176 — CU2. Dynamic loader of the build-time language catalogue artifact.
 *
 * ⚠️ Deliberately the only place in the whole application that names
 * `generatedLanguageCatalogue.json` with an `import`/`require` (S64, guarded by a static test in
 * `labelDetection.test.js`). The artifact is ~hundreds of KB and is never part of the startup
 * bundle: `import()` here makes webpack split it into a chunk that is only fetched the moment this
 * screen is actually opened.
 *
 * A thin wrapper, not a raw `import()` call spread across the component, purely so tests can mock
 * one module instead of reasoning about dynamic import syntax.
 */
export const loadLanguageCatalogueArtifact = () => import('../../../generatedLanguageCatalogue.json')
